import request from "../axios";

/**
 * 学校管理
 * **/
// 获取学校列表数据
export function getSchool(params) {
  return request({
    url: "/system/school",
    method: "get",
    params,
  });
}

// 获取学校所属镇街
export function getSchoolGroup(params) {
  return request({
    url: "/system/school/group",
    method: "get",
    params,
  });
}

// 创建学校
export function createSchool(data) {
  return request({
    url: "/system/school/store",
    method: "post",
    data
  });
}

// 编辑学校
export function updateSchool(data) {
  return request({
    url: "/system/school/store",
    method: "put",
    data
  });
}

// 删除学校
// export function deleteSchool(params) {
//   return request({
//     url: "/system/school/delete",
//     method: "delete",
//     params
//   });
// }

/**
 * 班级管理
 * **/
// 获取年级列表数据
export function getSchoolClass(params) {
  return request({
    url: "/system/school/class",
    method: "get",
    params,
  });
}
// 获取班级数据
export function getClassList(params) {
  return request({
    url: "/system/school/class/list",
    method: "get",
    params,
  });
}

// 保存班级信息
export function saveClass(data) {
  return request({
    url: "/system/school/class/save",
    method: "post",
    data
  });
}


/**
 * 教师管理
 * **/
// 获取教师列表数据
export function getTeacher(params) {
  return request({
    url: "/system/teachers",
    method: "get",
    params,
  });
}

// 创建教师
export function createTeacher(data) {
  return request({
    url: "/system/teachers/store",
    method: "post",
    data
  });
}

// 编辑教师
export function updateTeacher(data) {
  return request({
    url: "/system/teachers/store",
    method: "put",
    data
  });
}

// 删除教师
// export function deleteTeacher(params) {
//   return request({
//     url: "/system/teachers/delete",
//     method: "delete",
//     params
//   });
// }

// 教师excel上传数据校验
export function uploadTeacherCheck(data) {
  return request({
    url: "/system/teachers/check-excel",
    method: "post",
    data
  });
}

// 教师excel 下载模板
export function downTeacherTemp(params) {
  return request({
    url: "/system/teachers/down",
    method: "get",
    responseType: 'arraybuffer',
    params,
  });
}

// 教师excel上传数据保存
export function saveTeacherExcel(data) {
  return request({
    url: "/system/teachers/excel-store",
    method: "post",
    data
  });
}

/**
 * 教研员管理
 * **/
// 获取教研员列表数据
export function getStaff(params) {
  return request({
    url: "/system/staff",
    method: "get",
    params,
  });
}

// 创建教研员
export function createStaff(data) {
  return request({
    url: "/system/staff/store",
    method: "post",
    data
  });
}

// 编辑教研员
export function updateStaff(data) {
  return request({
    url: "/system/staff/store",
    method: "put",
    data
  });
}

// 删除教研员
export function deleteStaff(params) {
  return request({
    url: "/system/staff/delete",
    method: "delete",
    params
  });
}

/**
 * 评价量表管理
 * **/
// 获取维度主体
export function getMainEmbu(params) {
  return request({
    url: "/evaluate",
    method: 'get',
    params,
  })
}

// 新增维度主体
export function createMainEmbu(data) {
  return request({
    url: "/evaluate/store",
    method: "post",
    data
  })
}

// 编辑维度主体
export function updateMainEmbu(data) {
  return request({
    url: "/evaluate/store",
    method: "put",
    data
  })
}

// 删除维度主体
export function deleteEmbu(params) {
  return request({
    url: "/evaluate/delete",
    method: "delete",
    params,
  })
}

// 获取关联维度数据
export function getEmbuDimension(params) {
  return request({
    url: "/evaluate/dimension",
    method: 'get',
    params,
  })
}

// 新增关联维度
export function createEmbuDimension(data) {
  return request({
    url: "/evaluate/dimension/store",
    method: "post",
    data
  })
}

// 编辑关联维度
export function updateEmbuDimension(data) {
  return request({
    url: "/evaluate/dimension/store",
    method: "put",
    data
  })
}

// 删除维度
export function deleteEmbuDimension(params) {
  return request({
    url: "/evaluate/dimension/delete",
    method: "delete",
    params,
  })
}

/**
 * 专家管理
 * **/
// 获取专家管理数据
export function getExpert(params) {
  return request({
    url: "/system/expert",
    method: 'get',
    params,
  })
}
// 新增专家管理
export function createExpertStore(data) {
  return request({
    url: "/system/expert/store",
    method: "post",
    data
  })
}
// 编辑专家管理
export function updateExpertStore(data) {
  return request({
    url: "/system/expert/store",
    method: "put",
    data
  })
}
// 删除专家管理
export function deleteExpertStore(params) {
  return request({
    url: "/system/expert/delete",
    method: "delete",
    params,
  })
}

/**
 * 思维课堂评价量表-框架
 * **/
// 获取思维课堂评价量表列表数据
export function getLessonEmbu(params) {
  return request({
    url: "/tsc/main/index",
    method: 'get',
    params,
  })
}
// 新增思维课堂评价量表
export function createLessonEmbu(data) {
  return request({
    url: "/tsc/main/store",
    method: "post",
    data
  })
}
// 编辑思维课堂评价量表
export function updateLessonEmbu(data) {
  return request({
    url: "/tsc/main/store",
    method: "put",
    data
  })
}
// 删除思维课堂评价量表
export function deleteLessonEmbu(params) {
  return request({
    url: "/tsc/main/delete",
    method: "delete",
    params,
  })
}

/**
 * 思维课堂评价量表-维度
 * **/
// 获取思维课堂评价量表维度列表数据
export function getLessonDim(params) {
  return request({
    url: "/tsc/dimension/index",
    method: 'get',
    params,
  })
}
// 新增思维课堂评价量表维度
export function createLessonDim(data) {
  return request({
    url: "/tsc/dimension/store",
    method: "post",
    data
  })
}
// 编辑思维课堂评价量表维度
export function updateLessonDim(data) {
  return request({
    url: "/tsc/dimension/store",
    method: "put",
    data
  })
}
// 删除思维课堂评价量表维度
export function deleteLessonDim(params) {
  return request({
    url: "/tsc/dimension/delete",
    method: "delete",
    params,
  })
}
// 获取思维课堂评价量表维度明细
export function getLessonDimDetail(params) {
  return request({
    url: "/tsc/dimension/detail",
    method: 'get',
    params,
  })
}
// 配置保存思维课堂评价量表维度
export function saveLessonDim(data) {
  return request({
    url: "/tsc/dimension/option",
    method: "post",
    data
  })
}

/**
 * 思维课堂评价量表-维度-关联的学生课堂表现
 * **/
// 获取关联的学生课堂表现列表数据
export function getLessonPerformance(params) {
  return request({
    url: "/tsc/dimension/student/index",
    method: 'get',
    params,
  })
}
// 新增关联的学生课堂表现
export function createLessonPerformance(data) {
  return request({
    url: "/tsc/dimension/student/store",
    method: "post",
    data
  })
}
// 编辑关联的学生课堂表现
export function updateLessonPerformance(data) {
  return request({
    url: "/tsc/dimension/student/store",
    method: "put",
    data
  })
}
// 删除关联的学生课堂表现
export function deleteLessonPerformance(params) {
  return request({
    url: "/tsc/dimension/student/delete",
    method: "delete",
    params,
  })
}

/**
 * 思维课堂评价量表-学校框架
 * **/
// 获取学校思维课堂评价量表列表数据
export function getSchoolLessonEmbu(params) {
  return request({
    url: "/tsc/school/main/index",
    method: 'get',
    params,
  })
}
// 新增学校思维课堂评价量表
export function createSchoolLessonEmbu(data) {
  return request({
    url: "/tsc/school/main/store",
    method: "post",
    data
  })
}
// 编辑学校思维课堂评价量表
export function updateSchoolLessonEmbu(data) {
  return request({
    url: "/tsc/school/main/store",
    method: "put",
    data
  })
}
// 删除学校思维课堂评价量表
export function deleteSchoolLessonEmbu(params) {
  return request({
    url: "/tsc/school/main/delete",
    method: "delete",
    params,
  })
}

/**
 * 思维课堂评价量表-学校维度
 * **/
// 获取学校思维课堂评价量表维度列表数据
export function getSchoolLessonDim(params) {
  return request({
    url: "/tsc/school/dimension/index",
    method: 'get',
    params,
  })
}
// 新增学校思维课堂评价量表维度
export function createSchoolLessonDim(data) {
  return request({
    url: "/tsc/school/dimension/store",
    method: "post",
    data
  })
}
// 编辑学校思维课堂评价量表维度
export function updateSchoolLessonDim(data) {
  return request({
    url: "/tsc/school/dimension/store",
    method: "put",
    data
  })
}
// 删除学校思维课堂评价量表维度
export function deleteSchoolLessonDim(params) {
  return request({
    url: "/tsc/school/dimension/delete",
    method: "delete",
    params,
  })
}
// 获取学校思维课堂评价量表维度明细
export function getSchoolLessonDimDetail(params) {
  return request({
    url: "/tsc/school/dimension/detail",
    method: 'get',
    params,
  })
}
// 配置保存学校思维课堂评价量表维度
export function saveSchoolLessonDim(data) {
  return request({
    url: "/tsc/school/dimension/option",
    method: "post",
    data
  })
}

/**
 * 学校课堂评价量表-维度-关联的学生课堂表现
 * **/
// 获取关联的学生课堂表现列表数据
export function getSchoolLessonPerformance(params) {
  return request({
    url: "/tsc/school/dimension/student/index",
    method: 'get',
    params,
  })
}
// 新增关联的学生课堂表现
export function createSchoolLessonPerformance(data) {
  return request({
    url: "/tsc/school/dimension/student/store",
    method: "post",
    data
  })
}
// 编辑关联的学生课堂表现
export function updateSchoolLessonPerformance(data) {
  return request({
    url: "/tsc/school/dimension/student/store",
    method: "put",
    data
  })
}
// 删除关联的学生课堂表现
export function deleteSchoolLessonPerformance(params) {
  return request({
    url: "/tsc/school/dimension/student/delete",
    method: "delete",
    params,
  })
}

/**
 * 公告管理
 * **/
// 获取公告列表
export function getNoticeList(params) {
  return request({
    url: "/system/notice/list",
    method: "get",
    params,
  });
}

// 新增公告
export function createNotice(data) {
  return request({
    url: "/system/notice/store",
    method: "post",
    data,
  });
}

// 编辑公告
export function updateNotice(data) {
  return request({
    url: "/system/notice/store",
    method: "put",
    data,
  });
}

// 删除公告
export function deleteNotice(params) {
  return request({
    url: "/system/notice/delete",
    method: "delete",
    params,
  });
}

// 获取未读公告（登录后弹窗用）
export function getNoticeUnread(params) {
  return request({
    url: "/system/notice",
    method: "get",
    params,
  });
}

// 标记公告已读
export function readNotice(data) {
  return request({
    url: "/system/notice/read",
    method: "post",
    data,
  });
}